import { BaseRemoteService } from "@ofqual/portal-core/core/dataAccess";
import { Model, Opts, QueryParams } from "@ofqual/portal-core/core/types";
import { paramsToSearchString } from "@ofqual/portal-core/core/utils/urlHelper";
import { DashboardTileModel } from "../presentation/dashboard/TileRenderers/types";

export class DashboardService extends BaseRemoteService {
  public async getAnalytics(
    params: QueryParams,
    opts: Opts
  ): Promise<DashboardTileModel> {
    const url = `${
      this.apiRoot
    }/publicenquiries/dashboard${paramsToSearchString(params)}`;
    const response = await super.getRequest<DashboardTileModel>(url, opts);
    return response;
  }

  public async getTeamAnalytics(opts: Opts): Promise<Model[]> {
    const url = `${this.apiRoot}/publicenquiries/teamanalytics`;
    return await this.getRequest<Model[]>(url, opts);
  }
}
